import React from 'react';

import { OtpSession } from './useSubscribeToPriceChange';

import { ConfirmEmailModal } from './components/ConfirmEmailModal';
import { SubscribeToPriceSuccessModal } from './components/SubscribeToPriceSuccessModal';

type Props = {
    modalName: string;
    handleClose: () => void;
    email: string;
    otpSession: OtpSession;
    onResetEmail: () => void;
    verifyEmail: (confirmCode: string) => void;
}

export const SubscribeToPriceModal = (props: Props) => {
    const {
        modalName,
        handleClose,
        email,
        verifyEmail,
        onResetEmail,
        otpSession
    } = props;

    switch (modalName) {
        case 'confirmEmail': {
            return (
                <ConfirmEmailModal
                    onClose={handleClose}
                    email={email}
                    otpSession={otpSession}
                    onResetEmail={onResetEmail}
                    verifyEmail={verifyEmail}
                />
            );
        }
        case 'subscribeToPriceChangeSuccess': {
            return (
                <SubscribeToPriceSuccessModal onClose={handleClose} />
            );
        }
        default:
            return null;
    }
};
